import Axios from "axios";

const local = "https://testnet.switchwallet.io";
const live = "http://mainnet.switchwallet.io";

const baseuri = Axios.create({
  baseURL: window.location.hostname === "localhost" ? local : live,
});

export default baseuri;